module.exports = {"facts":[{},{},{},{},{}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/facts_gen.json
// module id = rgXG
// module chunks = 1